import { Component, inject } from '@angular/core';

import { BaseComponent } from 'src/app/core/components/base/base.component';
import { OnboardingStatus } from 'src/app/core/enum/OnboardingStatus';
import { AuthService } from 'src/app/core/services/auth';
import { OnboardingService } from 'src/app/core/services/onboarding';
import { SharedService } from 'src/app/core/services/shared';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent extends BaseComponent {
  authService = inject(AuthService);
  onboardingService = inject(OnboardingService);
  sharedService = inject(SharedService);
  appName = this.sharedService.GetAppName();
  initOnboarding(): void {
    const loaderRef = this.loader.open('Iniciando processo de onboarding...');

    this.onboardingService
      .initOnboarding()
      .pipe(this.takeUntilDestroyed())
      .subscribe({
        next: () => {
          this.authService.setOnboardingStatusToLocalStorage(
            OnboardingStatus.Beneficios
          );
          this.router.navigate(['onboarding']);
        },
        error: () => this.showInitOnboardingErrorNotification(),
      })
      .add(() => loaderRef.close());
  }

  private showInitOnboardingErrorNotification(): void {
    const msg =
      'Ops, houve um erro ao iniciar o onboarding. Tente novamente mais tarde.';

    this.notification.info(msg);
  }
}
